import { DetailsTableRow } from "@/components/table/DetailsTableRow.tsx";
import { BillingAccountLink } from "@/modules/billing/BillingAccountLink.tsx";
import {
    EditableBillingSelect,
    type EditableBillingSelectProps,
} from "@/modules/billing/forms/EditableBillingSelect.tsx";
import { Trans, useLingui } from "@lingui/react/macro";
import type { BillingAccountId } from "@warrenio/api-spec/spec.oats.gen";

export interface DetailsTableBillingAccountProps extends Omit<EditableBillingSelectProps, "isReadOnly"> {
    isGlobal?: boolean;
}

export function DetailsTableBillingAccount({ isGlobal, ...props }: DetailsTableBillingAccountProps) {
    const { t } = useLingui();
    const isReadOnly = !props.onChange;
    return (
        <DetailsTableRow title={t`Billing account`}>
            {isGlobal ? <Trans>All</Trans> : <EditableBillingSelect isReadOnly={isReadOnly} {...props} />}
        </DetailsTableRow>
    );
}

export function DetailsTableBillingAccountReadOnly({ billingAccountId }: { billingAccountId: BillingAccountId }) {
    const { t } = useLingui();

    return (
        <DetailsTableRow title={t`Billing account`}>
            <BillingAccountLink billingAccountId={billingAccountId} />
        </DetailsTableRow>
    );
}
